export function testId(id: string): { "data-testid": string } | Record<string, never> {
  return process.env.ENABLE_TEST_IDS === "true" ? { "data-testid": id } : {};
}
